import { DefinitionList, DefinitionListItem, Link } from "@funcional/react-ui";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { IProgramFamily } from "@pbm/programs-families/contracts";

export function ProgramFamilyCard({
  programFamily,
}: {
  programFamily: IProgramFamily;
}) {
  return (
    <>
      <DefinitionList className="mb-8">
        <DefinitionListItem label="Código">
          {programFamily.code}
        </DefinitionListItem>
        <DefinitionListItem label="Nome">
          {programFamily.name}
        </DefinitionListItem>
        <DefinitionListItem label="Criada em">
          <IntlDateTime value={programFamily.createdAt} />
        </DefinitionListItem>
        <DefinitionListItem label="Atualizada em">
          <IntlDateTime value={programFamily.updatedAt} />
        </DefinitionListItem>
        {programFamily.deletedAt ? (
          <DefinitionListItem label="Excluída em">
            <IntlDateTime value={programFamily.deletedAt} />
          </DefinitionListItem>
        ) : null}
        <DefinitionListItem label="Início da vigência">
          <IntlDateTime value={programFamily.effectiveSince} />
        </DefinitionListItem>
        <DefinitionListItem label="Fim da vigência">
          <IntlDateTime value={programFamily.effectiveUntil} />
        </DefinitionListItem>
        <DefinitionListItem label="Política cadastral">
          {programFamily.registrationPolicy ? (
            <Link
              to={`/pbm/registration-policies/${programFamily.registrationPolicy.id}`}
            >
              {programFamily.registrationPolicy.description}
            </Link>
          ) : (
            "Não há política cadastral associada"
          )}
        </DefinitionListItem>
      </DefinitionList>
    </>
  );
}
